'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { MenuIcon, XIcon } from 'lucide-react';

import { navItems } from './constants';
import ThemeButton from '@/components/ui/ThemeButton/ThemeButton';

const iconSize = 30;

const NavMenuMobile = () => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleCreateClick = () => {
    toggleMenu();
    router.push('/#create-nook-form');
  };

  return (
    <>
      <button
        className='sm:hidden btn btn-square btn-ghost'
        onClick={toggleMenu}
        aria-expanded={isOpen}
        aria-label="Toggle mobile menu"
      >
        <MenuIcon size={iconSize} />
      </button>

      {/* Background Box */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 sm:hidden z-40 transition-opacity duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        onClick={toggleMenu}
        aria-hidden="true"
      />

      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-4/5 max-w-xs bg-base-200 shadow-xl z-50 sm:hidden rounded-tl-lg rounded-bl-lg
                    transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'
          } flex flex-col`}
        aria-hidden={!isOpen}
      >
        {/* Top Panel */}
        <div className='flex justify-between p-4'>
          <ThemeButton size={iconSize} />
          <button onClick={toggleMenu} className='btn btn-square btn-ghost'>
            <XIcon size={iconSize} />
          </button>
        </div>

        {/* Nav Items - Scrollable */}
        <div className='flex-1 overflow-y-auto px-8 border-t border-b border-[var(--color-primary)]'>
          <div className='py-2'>
            {navItems.map((item, index) => (
              <Link key={`navigation-item-${item.key}`} href={item.path} onClick={toggleMenu}>
                <p
                  className='text-xl font-medium text-[var(--color-primary)] hover:underline py-6 border-b transform transition-all duration-300 ease-out'
                  style={{
                    transitionDelay: isOpen ? `${150 + index * 75}ms` : '0ms',
                    opacity: isOpen ? 1 : 0,
                    transform: isOpen ? 'translateX(0)' : 'translateX(2rem)'
                  }}
                >
                  {item.title}
                </p>
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Panel */}
        <div className='p-4'>
          <button className='btn btn-accent w-full' onClick={handleCreateClick}>
            Create a nook
          </button>
        </div>
      </div>
    </>
  );
};

export default NavMenuMobile;
